import React, { useCallback, useEffect, useRef } from "react";
import { app_url } from "../../config";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { DateRangePicker } from "react-date-range";
import { addDays, setSeconds, setHours, setMinutes } from "date-fns";
import { formatDate } from "../../formatDate/formatDate";
import Error500 from "../500/Error500";
import _ from "lodash";
import Pagination from "./Pagination";
import "./PartnerOrdersTable.css";

const PartnerOrdersTable = ({ partnerId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const navigate = useNavigate();
  const datePickerRef = useRef(null);
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [networkIssue, setNetworkIssue] = useState(false);
  const [failed, setFailed] = useState("");
  const [tableData, setTableData] = useState([]);
  const [dataOnPage, setDataOnPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [calendarMonths, setCalendarMonths] = useState(2);

  // console.log(partnerId, "partner id check");

  // Pagination Calculations
  const itemsPerPage = dataOnPage;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // console.log(indexOfLastItem, "index of item check");

  /* Date Range Picker */
  function getLastDayOfMonth(year, month) {
    const nextMonth = month + 1;
    const date = new Date(year, nextMonth, 0);
    return date.getDate();
  }
  const month = new Date().getMonth();
  const year = new Date().getFullYear();

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const getStartDateForInitialState = () => {
    const actualDate = addDays(new Date(), +1 - new Date().getDate());
    const adjustedStartDate = setSeconds(
      setMinutes(setHours(actualDate, 0), 0),
      0
    );
    return adjustedStartDate;
  };

  const [state, setState] = useState([
    {
      startDate: getStartDateForInitialState(),
      endDate: new Date(year, month, getLastDayOfMonth(year, month)),
      key: "selection",
    },
  ]);

  //update dateFrom and dateTo based on state changes
  useEffect(() => {
    const formattedStartDate = formatDate(state[0].startDate);
    const formattedEndDate = formatDate(state[0].endDate);

    setdateFrom(formattedStartDate);
    setdateTo(formattedEndDate);
  }, [state]);
  /* Date Range Picker end*/

  // Date Picker outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* new Date Picker Data */
  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const adjustedEndDate = setSeconds(
      setMinutes(setHours(endDate, 23), 59),
      59
    );
    const adjustedStartDate = setSeconds(
      setMinutes(setHours(startDate, 0), 0),
      0
    );
    setState([
      {
        startDate: adjustedStartDate,
        endDate: adjustedEndDate,
        key: "selection",
      },
    ]);
  };

  const [dateFrom, setdateFrom] = useState(formatDate(state[0].startDate));
  const [dateTo, setdateTo] = useState(formatDate(state[0].endDate));

  useEffect(() => {
    const updateCalendarMonths = () => {
      setCalendarMonths(window.innerWidth < 768 ? 1 : 2);
    };

    updateCalendarMonths();
    window.addEventListener("resize", updateCalendarMonths);
    return () => window.removeEventListener("resize", updateCalendarMonths);
  }, []);

  const getStatusStyles = (status) => ({
    color:
      status === "paid" ? "#20af24" : status === "pending" ? "#FF0000" : "#606060",
    background:
      status === "paid" ? "#e4fae5" : status === "pending" ? "#ffe7e7" : "#EEE9E9",
  });

  // Debounced Fetch Function for API Call
  const fetchPartnerOrders = useCallback(
    _.debounce((searchValue) => {
      setIsLoading(true);
      if (partnerId !== undefined) {
        axios
          .get(
            `${app_url}/api/partner/getAllOrders?numPerPage=${dataOnPage}&page=${
              currentPage - 1
            }&from=${dateFrom}&to=${dateTo}&search=${searchValue}&partner_id=${partnerId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            if (itemsPerPage > res.data?.pagiantion?.dataCount) {
              setCurrentPage(1);
            }
            setTableData(res);
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            if (err.response) {
              const status = err.response.status;
              if (status === 400) {
                toast.error(err.response.data.message || "Bad Request");
              } else if (status === 401) {
                navigate("/");
              } else if (status === 500) {
                toast.error(
                  err.response.data.message || "Internal Server Error"
                );
              } else {
                toast.error("An unexpected error occurred.");
              }
            } else {
              setNetworkIssue(true);
              toast.error(
                "Network error. Please check your internet connection."
              );
              setFailed(
                "Network error. Please check your internet connection."
              );
            }
          });
      }
    }, 500),
    [dataOnPage, currentPage, token, partnerId, dateFrom, dateTo]
  );

  // console.log(tableData, "table data check");

  // useEffect to Fetch Data on Initial Render and Pagination Change
  useEffect(() => {
    fetchPartnerOrders(search);
  }, [search, dataOnPage, currentPage, partnerId, dateFrom, dateTo]);

  // Search Function with Debounce
  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  // console.log(dateTo, "date to check");

  const newArr = new Array(tableData?.data?.result?.length || 5).fill(
    <p className="placeholder-glow">
      <span className="placeholder col-12"></span>
    </p>
  );

  const skeleton = (
    <tbody>
      {newArr.map((item, index) => (
        <tr key={index}>
          <th scope="row" className="py-2 ps-5" data-label="#">
            {item}
          </th>
          <th scope="row" className="py-2" data-label="Order ID">
            {item}
          </th>
          <th
            scope="row"
            style={{ textTransform: "none" }}
            className="py-2"
            data-label="Created"
          >
            {item}
          </th>
          <th scope="row" className="text-center py-2" data-label="Payment">
            {item}
          </th>
          <th scope="row" className="text-center py-2" data-label="Type">
            {item}
          </th>
          <th scope="row" className="text-center py-2" data-label="Net Price">
            {item}
          </th>
          <th scope="row" className="text-center py-2" data-label="Sale Price">
            {item}
          </th>
          <th scope="row" className="text-center py-2" data-label="Status">
            {item}
          </th>
        </tr>
      ))}
    </tbody>
  );

  // Handle Pagination Page Change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (networkIssue) {
    return <Error500 message={failed} />;
  }

  return (
    <div className="partner-orders-table-section">
      {/* Date Filter */}
      <div className="d-flex flex-column flex-md-row pb-3 table-header-item mb-2 gap-2 gap-md-0">
        <div
          className="dropdown d-flex flex-wrap partner-orders-date-picker gap-2 gap-sm-3"
          ref={datePickerRef}
        >
          <button
            className="btn btn-white border dropdown-toggle"
            type="button"
            onClick={toggleDatePicker}
          >
            Select Date
          </button>
          <div className="d-flex flex-wrap align-items-center gap-1 dropdown">
            <div className="order-date">
              <span className="pe-2">From:</span>
              <button
                type="button"
                disabled
                className="text-black btn btn-white border "
              >
                {dateFrom}
              </button>
            </div>
            <div className="order-date">
              <span className="pe-2">To:</span>
              <button
                type="button"
                disabled
                className="text-black btn btn-white border "
              >
                {dateTo}
              </button>
            </div>
          </div>
          {showDatePicker && (
            <ul
              className="dropdown-menu px-2 py-0 show"
              style={{ top: "46px", left: "-20px" }}
            >
              <li className="my-2 dropdown-item">
                <DateRangePicker
                  onChange={handleSelect}
                  showSelectionPreview={true}
                  moveRangeOnFirstSelection={false}
                  months={calendarMonths}
                  ranges={state}
                  direction="horizontal"
                />
              </li>
            </ul>
          )}
        </div>
        <div className="d-flex justify-content-center align-items-center mt-md-0 mt-2 w-100 w-md-auto">
          <input
            className="form-control partner-orders-search"
            type="search"
            placeholder="Search by Order Id or email"
            aria-label="Search"
            value={search}
            onChange={searchData}
          />
        </div>
      </div>

      <div className="partner-orders-table-scroll">
        <table className="table table-tb partner-orders-table mb-0">
          <thead>
            <tr className="rounded">
              <th className="tr-tt fw-bold ps-5" scope="col">
                #
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Order ID
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Created
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Payment
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Type
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Net Price
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Sale Price
              </th>
              <th className="tr-tt fw-bold" scope="col">
                Status
              </th>
            </tr>
          </thead>

          {isLoading ? (
            skeleton
          ) : (
            <tbody>
              {tableData?.data?.result?.length === 0 ? (
                <tr className="partner-orders-empty-row">
                  <td colSpan="8">No Data Found</td>
                </tr>
              ) : (
                tableData?.data?.result.map(
                  (
                    {
                      systemOrderId,
                      isTopUp,
                      paymentDate,
                      price,
                      netPrice,
                      status,
                      email,
                      createdAt,
                      process_pipeline,
                    },
                    index
                  ) => {
                    const statusStyles = getStatusStyles(status);

                    return (
                      <tr title="Click to see details" key={index}>
                        <th
                          className="py-2 ps-5 align-middle"
                          data-label="#"
                        >
                          {index + 1}
                        </th>
                        <th
                          className="py-2 align-middle text-lowercase"
                          data-label="Order ID"
                        >
                          {systemOrderId.length >= 20 ? (
                            <Link
                              title={systemOrderId}
                              to={`/orders/${systemOrderId}`}
                            >
                              {systemOrderId.substring(0, 20)}...
                            </Link>
                          ) : (
                            <Link
                              title={systemOrderId}
                              to={`/orders/${systemOrderId}`}
                            >
                              {systemOrderId}
                            </Link>
                          )}{" "}
                          <br />
                          {email}
                        </th>
                        <th className="py-2 align-middle" data-label="Created">
                          {new Date(createdAt).toLocaleString()}
                        </th>
                        <th className="py-2 align-middle" data-label="Payment">
                          {paymentDate === null
                            ? "N/A"
                            : new Date(paymentDate).toLocaleString()}
                        </th>
                        <th className="py-2 align-middle" data-label="Type">
                          {isTopUp === 0 ? (
                            <img
                              src="/assets/images/esim.png"
                              width={30}
                              height={35}
                              alt="eSIM"
                            />
                          ) : (
                            <img
                              src="/assets/images/topups.png"
                              width={30}
                              height={35}
                              alt="Topup"
                            />
                          )}
                        </th>
                        <th className="py-2 align-middle" data-label="Net Price">
                          ${netPrice?.toFixed(2)}
                        </th>
                        <th
                          className="py-2 align-middle"
                          data-label="Sale Price"
                        >
                          ${price?.toFixed(2)}
                        </th>
                        <th
                          className="py-2 align-middle partner-orders-status-cell"
                          data-label="Status"
                        >
                          <span
                            className="partner-orders-status-badge"
                            style={statusStyles}
                          >
                            {status}
                          </span>
                          <span
                            className="partner-orders-status-pipeline"
                            style={{ color: statusStyles.color }}
                          >
                            ({process_pipeline.replace(/_/g, " ")})
                          </span>
                        </th>
                      </tr>
                    );
                  }
                )
              )}
            </tbody>
          )}
        </table>
      </div>
      <div className="partner-orders-pagination">
        <Pagination
          dataOnPage={dataOnPage}
          currentPage={currentPage}
          totalPages={Math.ceil(tableData?.data?.pagiantion.pages)}
          tabledata={tableData}
          onPageChange={handlePageChange}
          indexOfFirstItem={indexOfFirstItem}
          itemsPerPage={itemsPerPage}
          indexOfLastItem={indexOfLastItem}
        />
      </div>
    </div>
  );
};

export default PartnerOrdersTable;
